import { useState, useMemo, useEffect, useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import useDataFetcher from '../../../hooks/useFetchData'
import { IGrowerNodeGetResponse } from '../../../../../../../modules/API/Defaults/models/growers'
import { Defaults } from '../../../../../../../modules/API/Defaults/defaults'
import { ICarItemResponse } from '../../../../../../../modules/API/Defaults/models/cars'
import { IProductsWithVarietyItem } from '../../../../../../../modules/API/Defaults/models/compliteProducts'
import { IWarhouseListItem } from '../../../../../../../modules/API/Defaults/models/warhouseList'
import { IEntrie, IEntrieDetails, IEntriesKnisotItem } from '../../../../../../../modules/API/Knisot/models/entrie'
import { IGetReuqestResponseNode } from '../../../../../../../modules/API/Defaults/models/pallets'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../../../../../store/reducers/rootReducer'
import { IPackagesItem } from '../../../../../../../modules/API/Defaults/models/packages'
import { Knisot } from '../../../../../../../modules/API/Knisot/knisot'
import { IEntriesItem } from '../../../../../../../modules/API/Miun/models/sortingList'
import { IEntriePutData } from '../../../../../../../modules/API/Market/models/putRequestInterface'
import { CLEAR_ENTRY_DETAILS, CREATE_ENTRIE_DETAILS, LOAD, LOAD_END } from '../../../../../../../../store/actions/actionsTypes'
import { createObjectsArray } from '../../Components/Helpers/createObjectsArray'
import { pickCreatedDetails } from '../../Components/Helpers/pickCreatedDetails'

import { ISizeItem } from '../../../../../../../modules/API/Products/models/size'
import { Product } from '../../../../../../../modules/API/Products/products'
import { LINKS } from '../../../../../../../Routs/config'
import { ITeudotTypeItem } from '../../../../../../../modules/API/Defaults/models/teudotTypes'
import { IPrinterData } from '../../../../../../../modules/API/Defaults/models/printSticker'
import { SET_IS_OPEN } from '../../../../../../../../store/reducers/printer'
import { useTranslation } from 'react-i18next'
import { IPutDivideData } from '../../../../../../../modules/API/Miun/models/fetchData'
import { Miun } from '../../../../../../../modules/API/Miun/miun'
import { addIDForTheList } from '../../../../../../../generic/utils/addUIDForTheList'
import useWorkerType, { ENUM_WORKER_TYPES } from '../../../../../../../generic/hooks/useWorkerType'
import { handleNotifications } from '../../../../../../../generic/utils/handleNotifications'
import { IRecommendationItem } from '../../../../../../../modules/API/Recommendation/models/recomendationItem'
import { Recommendation } from '../../../../../../../modules/API/Recommendation/Recommendation'
import { IMarketPalletDetails, IPostProduct, IUpdateProduct } from '../../../../../../../modules/API/Market/models/marketRequests'
import { Market } from '../../../../../../../modules/API/Market/market'
import { Pallets } from '../../../../../../../modules/API/Pallets/pallets'
import { format } from 'date-fns'

export interface IMarketPalletDetailsResponse {
  palletNum: number,
  message: string,
  lines18: IMarketPalletDetails[]
}

export interface IDetailsSelected {
  productQty: number,
  productID: number,
  varietyID: number,
  price: number,
  weight: number,
  remark: string,
  palletID: number,
  palletQty: number,
  packageID: number,
  externalPalletNum: number,
  sizeID: number,
  tranzit: number,
  weightNetto: number,
  expiryDate: string,
  location: string
}

const useCreateKnisa = () => {
  const [t] = useTranslation(['knisa', 'buttons'])
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {id} = useParams() as {id: string}
  const user = useSelector((state: RootState) => state.mainReducer.user)
  const { type } = useWorkerType({codeInternal: user?.code_internal || ''})
  const isOffice = user?.rights?.includes('OFFICE') || type === ENUM_WORKER_TYPES.ADMIN
  const printerState = useSelector((state: RootState) => state.printerReducer)
  const {title, details} = useSelector((state: RootState) => state.entryReducer.create)
  const packageList: IPackagesItem[] = useSelector((state: RootState) => state.defaults.packageList)
  const [isOpenTitle, setIsOpenTitle] = useState<boolean>(false)
  const [isOpenProduct, setIsOpenProduct] = useState<boolean>(false)
  const [knisaTitleData, setKnisaTitleData] = useState<IEntrieDetails | null>(title)
  const [knisaDetailsData, setKnisaDetailsData] = useState<IEntriesKnisotItem[] | null>(details)
  const [selectedItem, setSelectedItem] = useState<IEntriesKnisotItem | null>(null)
  const [searchDetails, setSearchDetails] = useState<string>('')
  const [selectedEntryItem, setSelectedEntryItem] = useState<IEntriesKnisotItem | null>(null)
  const [isOpenEntryPallets, setIsOpenEntryPallets] = useState<boolean>(false)

  // console.log(selectedItem)
  useEffect(() => {
    if(title || id ) return
    setTimeout(() => {
      setIsOpenTitle(true)
    }, 100)
  }, [])
  const {
    data: growerList
  } =  useDataFetcher<IGrowerNodeGetResponse>(
    Defaults.getGrowerList, 'data'
  )
  const {
    data: carList
  } = useDataFetcher<ICarItemResponse>(
    Defaults.getCarList, 'data'
  )
  const {
    data: warehouseList
  } = useDataFetcher<IWarhouseListItem[]>(
    Defaults.getWarhouseList, 'data'
  )
  const {
    data: productsWithVariety
  } = useDataFetcher<IProductsWithVarietyItem[]>(
    Defaults.getProductsWithVariety, 'data'
  )
  const {
    data: palletTypeList
  } = useDataFetcher<IGetReuqestResponseNode>(
    Defaults.getPalletTypes, 'data'
  )
  const {
    data: sizeList
  } = useDataFetcher<{sizes: ISizeItem[]}>(
    Product.getSizes, 'data'
  )
  const {
    data: teudaTypes
  } = useDataFetcher<ITeudotTypeItem[]>(
    Defaults.getTblTeudotTypes, 'כ'
  )

  const {
    data: productListByGrower
  } = useDataFetcher<IRecommendationItem[]>(
    Recommendation.getRecommendationByGrowerID,
    `${knisaTitleData?.Grower || '0'}`
  )
  const isAllowToShowTitle = isOpenTitle && warehouseList && teudaTypes
  // console.log(config)
  const handleControlTitle = (isSave?: boolean) => {

    setIsOpenTitle(!isOpenTitle)
    if(!!!isSave) return handleBack()
  }
  const handleControlProduct = () => {
    setIsOpenProduct(!isOpenProduct)
    setSelectedItem(null)
  }

  console.log(knisaDetailsData)

  const handlePrintKnisa = async (entryNum: number | string, palletNum?: number) => {
    const selectedPrinter = printerState.printerID
    const selectedFormat = palletNum ? printerState.formatID : printerState.entryFormat
    if(!selectedPrinter || !selectedFormat || (palletNum && !printerState.formatID)) {
        dispatch({type:SET_IS_OPEN, payload: true})
        return
    }
    const printerData: IPrinterData = {
        ZPL_15_75: palletNum ? 3 : 4,
        PalletEntryNum: palletNum || entryNum,
        PalletZPLFormat: selectedFormat,
        ChangeInternationalEncodingZPL: printerState.encoding
    }
    dispatch({type: LOAD})
    try {
        await Defaults.printSticker(selectedPrinter, printerData)
        if(palletNum) {
          handleNotifications(t('knisa_notification_printPalletSuccess', {num: palletNum}), {type: "success"})
        } else {
          handleNotifications(t('knisa_notification_printEntrySuccess', {num: entryNum}), {type: "success"})
        }
    } catch {
        handleNotifications(t('knisa_notification_printEntryFailure', {num: entryNum}), {type: "error"})
    } finally {
        dispatch({type: LOAD_END})
    }
  }
  const [isOpenMassPrint, setIsOpenMassPrint] = useState<boolean>(false)
  const [isMassPrinting, setIsMassPrinting] = useState<boolean>(false)

  const handleControlMassPrint = () => {
    setIsOpenMassPrint(!isOpenMassPrint)
  }

  const handleMassPrint = async () => {
    const selectedPrinter = printerState.printerID
    const rows = knisaDetailsData || []
    const needPalletFormat = rows.some(item => item.Pallet_Num !== 0)
    const needEntryFormat = rows.some(item => item.Pallet_Num === 0)
    if (
      !selectedPrinter ||
      (needPalletFormat && !printerState.formatID) ||
      (needEntryFormat && !printerState.entryFormat)
    ) {
      dispatch({type: SET_IS_OPEN, payload: true})
      return
    }
    setIsMassPrinting(true)
    dispatch({type: LOAD})
    try {
      await Promise.all(rows.map(item => {
        const palletNum = item.Pallet_Num !== 0 ? item.Pallet_Num : undefined
        const printerData: IPrinterData = {
          ZPL_15_75: palletNum ? 3 : 4,
          PalletEntryNum: palletNum || `${item.EntryNum}-${item.DetailNum}`,
          PalletZPLFormat: (palletNum ? printerState.formatID : printerState.entryFormat) ?? 0,
          ChangeInternationalEncodingZPL: printerState.encoding
        }
        return Defaults.printSticker(selectedPrinter, printerData)
      }))
      handleNotifications(t('knisa_notification_massPrintSuccess'), {type: 'success'})
      setIsOpenMassPrint(false)
    } catch {
      // модалку не закрываем — оператор может сразу повторить
      handleNotifications(t('knisa_notification_massPrintFailure'), {type: 'error'})
    } finally {
      setIsMassPrinting(false)
      dispatch({type: LOAD_END})
    }
  }

  const changeDeteilsItem = async (data: IEntriePutData ) => {
    if(!data.Details || !knisaTitleData || (selectedItem && selectedItem.Delivery_Num !== 0)) return console.log(knisaTitleData)
    try {
      const currentData = data.Details[0]

      const putData = {
        ...data,
        Details: data.Details.map(i => {
         const  {WeightNeto, ...rest} = i
         return {
          ...rest,
          ExpirationDate: i.ExpirationDate,
         }
        })
      }
      if(!currentData) return
      dispatch({type: LOAD})
      const {Details}: IEntrieDetails = await Knisot.putDetailsKnisa(knisaTitleData.EntryNum, putData)
      dispatch({type: 'CREATE_ENTRIE_DETAILS', payload: Details})
      setKnisaDetailsData(addIDForTheList(Details))
      if(selectedItem && selectedItem.PalletDetailRecID !== 0) {
        // const putData: IUpdateProduct = {
        //   PackID: currentData.TypePack,
        //   Pallet_Type: currentData.TypePallet,
        //   ProductID: currentData.ProductID,
        //   Quantity: currentData.AmountPack,
        //   Quantity_Pallets: currentData.AmountPallets || 0,
        //   Remarks: currentData.Remark,
        //   SalePrice: 0,
        //   SizeID: sizeList?.sizes.find(i => i.Code === currentData.SizeNum)?.Description || '',
        //   VarietyID: currentData.VarietyID,
        //   WeightBuy: currentData.WeightNeto || 0,
        //   WeightNeto: currentData.WeightNeto || 0,
        //   BuyPrice: 0,
        //   WeightBrutto: currentData.Gross || 0,
        //   Type_SaleCalculation: 0,
        //   Type_BuyCalculation: 0,
        //   GrowerID: knisaTitleData.Grower || 0,
        //   isIncludePallet: false,
        //   Reference_Delivery_Entry: 0,
        //   ExpirationDate: currentData.ExpirationDate || '',
        // }
        // await Market.updateProduct(selectedItem.PalletDetailRecID, putData)
      } else if (selectedItem && data.Details && data.Details.at(0)?.ToPallet) {
        const newData = {
          ...selectedItem,
          ...currentData,

        }
        await handleCreatePallet([newData], newData.ExternalPallet || 0, Details)
      }
      handleControlProduct()
    } catch (error) {
      handleNotifications(t('knisa_notification_genericError'), {type: "error"})
    } finally {
      dispatch({type: LOAD_END})
    }
  }
  const changeTitle = async (data: IEntrie) => {
    if(!knisaTitleData) return
    try {
      const {
        EntryNum,
        ...rest
      } = data
      const res: IEntrieDetails = await Knisot.putDetailsKnisa(knisaTitleData.EntryNum, rest)
      dispatch({type: 'CREATE_ENTRIE_TITLE', payload: res})
      setKnisaTitleData(res)
      handleControlTitle(true)
      handleNotifications(t('knisa_notification_entryUpdated'), {type: "success"})
    } catch (error) {
      handleNotifications(t('knisa_notification_genericError'), {type: "error"})
    }
  }

  const handleCreateTitle = async (data: IEntrieDetails) => {

    try {
      const {Details, ...rest} = data
      const res: IEntrie = await Knisot.createTitleKnisa(rest)
      dispatch({type: 'CREATE_ENTRIE_TITLE', payload: res})
      setKnisaTitleData({...res, Details})
      handleControlTitle(true)
    } catch (err: any) {
      let error
      if (err.response.status === 405) {
        error = t('knisa_notification_referenceExists', {date: err.response.data.error})
      }
      handleNotifications( error || t('knisa_notification_genericError'), {type: "error"})

    }
  }

/**
 * Создаёт паллеты по строкам книсы, которые только что создал сервер.
 *
 * `createdDetails` приходит отсортированным по `DetailNum` по убыванию, поэтому
 * ОРИГИНАЛ — строка, в которую вписали внешний номер, — идёт последним, а копии
 * перед ним. Раньше сюда передавалась одна строка и множитель, а номера деталей
 * для копий угадывались инкрементом — из-за этого паллеты уезжали на чужие строки.
 */
const handleCreatePallet = useCallback(async (
  createdDetails: IEntriesKnisotItem[],
  externalPalletNum: number,
  knisaDetailsData: IEntriesKnisotItem[]
) => {
  if(!knisaTitleData || createdDetails.length === 0) return
  const originalIndex = createdDetails.length - 1
  try {
      const res: IMarketPalletDetailsResponse[] = await Promise.all(
        createdDetails.map((detail, index) => {
          const reqData: IPostProduct = {
            EntryNum: `${knisaTitleData.EntryNum}-${detail.DetailNum}`,
            Quality: 0,
            AreaNum: 0,
            WarehouseID: knisaTitleData.Tranzit || 0,
            GrowerID: knisaTitleData.Grower || 0,
            ProductID: detail.ProductID,
            VarietyID: detail.VarietyID,
            PalletNum: 999999,
            OrderNum: 0,
            Qty: detail.AmountPack,
            Weight: detail.WeightNeto,
            PalletType: detail.TypePallet,
            OrderRowRecID: 0,
            CustomerID:  0,
            // Внешний номер уникален — его получает только оригинал, копии идут с нулём.
            // Из ответа его брать нельзя: сервер возвращает ExternalPallet нулём.
            ExternalNum: index === originalIndex ? externalPalletNum : 0,
            ScanProblem: 0,
            ChangeReason: 0,
            PackID: detail.TypePack,
            Reseller_Code: 0,
            SalePrice: 0,
            Type_SaleCalculation: 0,
            Type_BuyCalculation: 0,
            Remarks: detail.Remark,
            SizeID: detail.SizeDesc,
            PalletsQty: detail.AmountPallets,
            PackID_Secondary: 0,
            Quantity_Packs_Main: 0,
            Reference_Delivery_Entry : 0,
          }
          return Market.saveProduct(reqData)
        })
      )

      const createdLines = res.map(item => item.lines18[0]).filter(Boolean)
      const final = knisaDetailsData.map(item => {
        const line = createdLines.find(
          i => i.EntryNum === item.EntryNum && i.EntryNumRow === item.DetailNum
        )
        if(!line) return item
        return {
          ...item,
          PalletDetailRecID: line.RecID,
          Pallet_Num: line.Pallet_Num,
        }
      })
      dispatch({type: CREATE_ENTRIE_DETAILS, payload: final})
      setKnisaDetailsData(final)
  } catch (error) {
    handleNotifications(t('knisa_notification_genericError'), {type: "error"})
  } finally {
    dispatch({type: LOAD_END})
  }
}, [knisaTitleData, t])

  const handleAddDetailesItem = async (data: IDetailsSelected, isNeedToCreatePallet: boolean, addictional?: {multyplier: number, isCopyWithWeigh: boolean, isEdit: boolean}) => {
    if(!knisaTitleData) return
    dispatch({type: LOAD})
    const dataFormed: IEntriesKnisotItem = {
      DateEntry: format(new Date(), 'yyyyMMdd'),
      BalanceAmount: data.productQty,
      AmountPack: data.productQty,
      DetailNum: 0,
      EntryNum: knisaTitleData.EntryNum,
      Gross: data.weight,
      Tranzit: data.tranzit,
      PalletDetailsCount: 0,
      // ExternalPallet: 0,
      GrowerName: '',
      Pack_Name: '',
      Invoice: 0,
      ExternalPallet: +data.externalPalletNum || 0,
      // id?: string;
      // isSelected?: boolean;
      OutPackId: 0,
      // Given?: boolean,
      // Type?: string
      Delivery_Num: 0,
      Delivery_Sub: 0,
      Pallet_Num: 0,
      PalletDetailRecID: 0,
      AmountPallets: data.palletQty,
      Discount: 0,
      Pallete_Desc: '',
      PriceWeight: data.price,
      ProductDesc: '',
      ProductID: data.productID,
      SizeDesc: data.sizeID.toString(),
      SizeNum: data.sizeID,
      TypePack: data.packageID,
      TypePallet: data.palletID,
      VarietyDesc: '',
      VarietyID: data.varietyID,
      // Image: '',
      GeneralProductID: 0,
      CalculationMethod: 0,
      AmountReject:0,
      Reject: false,
      WeightReject: 0,
      PalletsReject: 0,
      Remark: data.remark,
      WeightNeto: data.weight,
      ToPallet: isNeedToCreatePallet,
      // EntryDetailNum: '',
      ExpirationDate: data.expiryDate,
      Locating: data.location || '',
    }
    /**
     * Из режима редактирования оригинал уже существует и правится отдельным PUT,
     * поэтому ВСЁ, что создаётся здесь, — копии: ни строка, ни её паллета не
     * должны получить внешний номер.
     */
    const isEditCopy = !!addictional?.isEdit
    const externalPalletNum = isEditCopy ? 0 : dataFormed.ExternalPallet

    let result:IEntriesKnisotItem[]  = [dataFormed]
    if (addictional?.multyplier) {

      result = createObjectsArray(
        dataFormed,
        addictional?.isEdit ? addictional.multyplier : addictional.multyplier + 1,
        addictional.isCopyWithWeigh,
        isEditCopy,
      )
    }

    try {
      const {Details}: IEntrieDetails = await Knisot.createDetailsKnisa(knisaTitleData.EntryNum, result)
      // console.log(res)
      dispatch({type: 'CREATE_ENTRIE_DETAILS', payload: Details})
      setKnisaDetailsData(addIDForTheList(Details))
      if (isNeedToCreatePallet) {
        // Сопоставляем отправленные строки с ответом: брать их по индексу нельзя —
        // сервер отдаёт весь список деталей теуды, а не только созданные.
        const createdDetails = pickCreatedDetails(result, Details)
        await handleCreatePallet(createdDetails, externalPalletNum, Details)
      }
      setSelectedItem(null)
      handleControlProduct()
    } catch (error) {
      handleNotifications(t('knisa_notification_genericError'), {type: "error"})
    } finally {
      dispatch({type: LOAD_END})
      }
  }

  const handleSelectDetailsItem = (item: IEntriesKnisotItem) => {
    if(!isOffice) return
    setSelectedItem(item)
    setIsOpenProduct(true)
  }

  const handleDeleteItem = async (item: IEntriesKnisotItem) => {
    if(!knisaTitleData || item.Delivery_Num !== 0) {
      handleNotifications(t('knisa_notification_cannotDeletePicked'), {type: "error"})
      return
    }
    dispatch({type: LOAD})
    try {
      await Knisot.deleteEntryDetail(knisaTitleData.EntryNum, item.DetailNum)
      const newArr = knisaDetailsData?.filter(i => i.DetailNum !== item.DetailNum)

      dispatch({type: CREATE_ENTRIE_DETAILS, payload: newArr})
      setKnisaDetailsData(newArr || [])
      if(item.PalletDetailRecID !== 0) {
        await Pallets.deletePalletGo(item.Pallet_Num)

        handleNotifications(t('knisa_notification_palletDeleted'), {type: "success"})
        return
      }
      handleNotifications(t('knisa_notification_entryDeleted'), {type: "success"})
    } catch (error) {
      handleNotifications(t('knisa_notification_genericError'), {type: "error"})

    } finally {
      dispatch({type: LOAD_END})
    }
  }

  const handleOpenEntryPallets = (item: IEntriesKnisotItem) => {
    // TODO: implement when API is ready
    return
    setSelectedEntryItem(item)
    setIsOpenEntryPallets(true)
  }

  const handleBack = () => {
    navigate(LINKS.knisot.teudot.mainURL)
    dispatch({type: CLEAR_ENTRY_DETAILS})
  }

  useEffect(() => {
    if(!id) return
    const fetchData = async () => {
      dispatch({type: LOAD})
      setIsOpenTitle(false)
      try {
        const res: IEntrieDetails = await Knisot.getEntryDetails(id)
        const {Details, ...rest} = res
        setKnisaTitleData(res)
        setKnisaDetailsData(addIDForTheList(Details))
      } catch (error) {
      } finally {
        dispatch({type: LOAD_END})

      }
    }
    fetchData()
  }, [id])

  const selectForDivide = (item: IEntriesKnisotItem) => {
    if(item.AmountPack <= 1 || item.PalletDetailRecID !== 0) {
      handleNotifications(t('knisa_notification_cannotDivide'), {type: "error"})

    return
    }
    setSelectedItemForDivide(item)
    handleOpenDivideModal()
  }

  const formatedGrowerList = useMemo(() => {
    if(!growerList) return []
    return growerList.growers.filter(i => i.Active)
  }, [growerList])

  const formedProductList = useMemo(() => {
    if(!productsWithVariety) return []
    const growerProducts = productListByGrower ? productListByGrower : []
    return productsWithVariety.map(item => {
      const match = growerProducts.find(i => i.ProductID === item.ProductID && i.VarietyID === item.VarietyID)
      if(!match) return item

      return {
        ...item,
        isHighlighted: true
      }
    }).sort((a, b) => a.isHighlighted ? -1 : 1)
  }, [productListByGrower, productsWithVariety])

  const render = useMemo(() => {
    if(!knisaDetailsData) return []
    return knisaDetailsData.filter(item =>
      `${item.ProductDesc.trim()} ${item.VarietyDesc.trim()}`.toLocaleLowerCase().includes(searchDetails.toLocaleLowerCase())
    )
  }, [searchDetails, knisaDetailsData])

  const modalProps = {
    fetchedKtisa: title || knisaTitleData,
    productsWithVariety: formedProductList,
    growerList: formatedGrowerList,
    carList: carList?.cars || [],
    warehouseList: warehouseList || [],
    createTitle: handleCreateTitle,
    teudaTypes: teudaTypes || [],
    changeTitle: changeTitle,
  }
  const addProductProps = {
    productsWithVariety: formedProductList,
    palletList: palletTypeList?.pallets || [],
    packageList: packageList || [],
    cashedDetails: selectedItem,
    warehouseList: warehouseList || [],
    sizeList: sizeList?.sizes || [],
    handleCreateDetails: handleAddDetailesItem,
    handleChangeDetails: changeDeteilsItem,
    handleControlModal: handleControlProduct,
    tranzitID: knisaTitleData?.Tranzit || 0,
    growerProductList: productListByGrower,
    growerID: knisaTitleData?.Grower || 0,
  }
  const detailsProps = {
    handleSelectItem: handleSelectDetailsItem,
    print: handlePrintKnisa,
    isOffice: isOffice,
    handleDeleteItem: handleDeleteItem,
    selectForDivide: selectForDivide,
    onBadgeClick: handleOpenEntryPallets,
  }

  const [isOpenDivideModal, setIsOpenDivideModal] = useState<boolean>(false)
  const [selectedItemForDivide, setSelectedItemForDivide] = useState<IEntriesKnisotItem | null>(null)

  const handleOpenDivideModal = () => {
    setIsOpenDivideModal(!isOpenDivideModal)
  }


  const fetchDivide = async (putData: IPutDivideData, restItem: IEntriesKnisotItem, item: IEntriesKnisotItem) => {
    dispatch({type: LOAD})
    try {
      let res: IEntriesItem = await Miun.putDivideEntrie(putData)
      if(!knisaDetailsData) return

      let newArr = [...knisaDetailsData].map(knisa => {
        if(knisa.EntryNum === restItem.EntryNum && knisa.DetailNum === restItem.DetailNum) {
          knisa = {
            ...restItem,
            Gross: Math.round(knisa.Gross - res.Gross),
            AmountPack: knisa.AmountPack - res.AmountPack
          }
        }
        return knisa
      })
      let pushItem = addIDForTheList([{
        ...item,
        ...res
      }])
      newArr.push(...pushItem)
      setKnisaDetailsData(newArr)
      handleOpenDivideModal()
    } catch (err) {

    }
    finally {
      dispatch({type: LOAD_END})
    }
  }

  const saveDevidedItem = (
    item: IEntriesKnisotItem,
    qty: number,
    restItem: IEntriesKnisotItem,
    tranzit: number,
    packID: number
  ) => {
    if(qty < 1 || item.AmountPack <= qty){
      handleNotifications(t('knisa_notification_cannotDivide'), {type: "error"})
      return
    }
    const putData = {
      AmountPack: +qty,
      DetailNum: item.DetailNum,
      EntryNum: item.EntryNum,
      Gross: Math.round((item.Gross / item.AmountPack) * qty),
      OutPackId: packID ? packID : item.OutPackId,
      Tranzit: tranzit
    }
    fetchDivide(putData, restItem, item)
  }

  const divideModalP = {
    item: selectedItemForDivide,
    saveFunc: saveDevidedItem,
    warehouseList: warehouseList || [],
    packageList: packageList || []
  }

  return {
    // i18n + routing
    t,
    id,
    // UI flags
    isOpenProduct,
    isOpenDivideModal,
    isOpenEntryPallets,
    isAllowToShowTitle,
    isOffice,
    // Data
    knisaTitleData,
    knisaDetailsData,
    selectedItem,
    selectedItemForDivide,
    selectedEntryItem,
    searchDetails,
    render,
    // Props bags
    modalProps,
    addProductProps,
    detailsProps,
    divideModalP,
    // Handlers
    setSearchDetails,
    isOpenMassPrint,
    isMassPrinting,
    handleControlMassPrint,
    handleMassPrint,
    handleControlTitle,
    handleControlProduct,
    handleOpenDivideModal,
    setIsOpenEntryPallets,
    handleBack,
  }
}

export default useCreateKnisa
